module.exports = __webpack_public_path__ + "5f10efd345d8a881d6dca1112d0adc2b.svg";